module.exports = __webpack_public_path__ + "static/media/amarBibaho.8507b065.png";